// extracted by mini-css-extract-plugin
module.exports = {"copyWrapper":"styles_copyWrapper__1BtqP","copyBtn":"styles_copyBtn__2L1gn","msg":"styles_msg__24_sE"};